import React, { FunctionComponent } from 'react';
import { View } from 'react-native';
import { Svg, Path } from 'react-native-svg';

import { Color } from '~/components/color';

import { IconProps } from './icon-types';

export const ButtonBackIcon: FunctionComponent<IconProps> = ({ fill, size = 24 }) => {
    return (
        <View style={{ width: size, height: size }}>
            {/* @ts-ignore see https://github.com/react-native-svg/react-native-svg/issues/1471 */}
            <Svg accessibilityRole="image" viewBox="0 0 24 24" focusable={false} tabIndex="-1">
                <Path
                    d="M6 10L13.8218 10C16.1293 10 18 11.8707 18 14.1782V14.1782C18 15.3447 17.5366 16.4634 16.7118 17.2882L14 20"
                    strokeWidth={2}
                    fill={Color.TRANSPARENT}
                    stroke={fill ?? Color.ALMOST_BLACK}
                    // @ts-ignore
                    tabIndex="-1"
                />
                <Path d="M11 5L6 10L11 15" strokeWidth="2" strokeLinecap="round" stroke={fill ?? Color.ALMOST_BLACK} />
            </Svg>
        </View>
    );
};
